import { Button } from "../Elements";
import { formatCurrency } from "../../../lib/helpers";


type Props = {
    isLoading: boolean,
    isDisable: boolean,
    paymentAmount: string
}
const PayButton = (props: Props) => {
    const { isDisable, isLoading, paymentAmount } = props;


    return (
        <div className="items-center flex justify-center">
            <Button
                type="submit"
                color="primary"
                hover="primary"
                className={" mt-6 px-7 py-3 min-w-80 flex justify-around "}
                size="xl"
                disabled={isDisable || isLoading}
                loading={isLoading}

            >
                <span className="mr-2 font-bold text-lg">
                    {formatCurrency(paymentAmount)} TL
                </span>
                <span className="font-bold text-lg">Ödeme Yap </span>

            </Button>
        </div>

    );
}
export default PayButton;